import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../../server-parameters'
import { yearsAgo, passportInputHandler } from '../../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../../validate/validators'
import { Country, Lang } from '../../../../../types/common-types'
import { State } from '../../../../../state-actions-reducers'
import FileInput from '../../../../../shared/Inputs/FileInput/FileInput'
import { PassportType } from '../../../../../enums/passportTypeEnum'
import CheckBoxInput from '../../../../../shared/Inputs/CheckBoxInput/CheckBoxInput'

export default function RussianForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      {Number(state.passportType) === PassportType.Passport ? (
        <>
          <div className="col-2 col-xs-12">
            {/* PASSPORT SERIES / NUMBER */}
            <TextInput
              testName={'passportNumber'}
              testErrorName={'error-passportNumber'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.passportNumber}
              onChange={passportNumber => {
                setValue('passportNumber', passportNumber, { shouldDirty: true })
              }}
              value={state.passportNumber}
              required
              valid={
                passportDigits(state.passportNumber) &&
                !errors.passportNumber
              }
              onBlur={() => setFocus('')}
              mask={'9999 999999'}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* PASSPORT ISSUED BY */}
            <TextInput
              testName={'issuedBy'}
              testErrorName={'error-issuedBy'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-2 col-xs-12">
            {/* PASSPORT ISSUE DATE */}
            <DatePicker
              testName={'passportIAt'}
              testErrorName={'error-passportIAt'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportIAt"
              onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
              value={state.passportIAt}
              required
              valid={
                !errors.passportIAt &&
                validateDate({
                  current: state.passportIAt,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              curr={
                state.birthDate
                  ? new Date(
                    new Date(state.birthDate).setFullYear(
                      new Date(state.birthDate).getFullYear() + 14
                    )
                  )
                  : new Date()
              }
              min={
                state.birthDate
                  ? new Date(
                    new Date(state.birthDate).setFullYear(
                      new Date(state.birthDate).getFullYear() + 14
                    )
                  )
                  : new Date(
                    new Date().setFullYear(new Date().getFullYear() - 67)
                  )
              }
              max={new Date()}
            />
          </div>
          <div className="col-2 col-xs-12">
            {/* PASSPORT AUTHORITY CODE */}
            <TextInput
              testName={'passportAuthorityCode'}
              testErrorName={'error-passportAuthorityCode'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.passportAuthorityCode}
              onChange={passportAuthorityCode => {
                const authorityCode = passportInputHandler({
                  newValue: passportAuthorityCode,
                  oldValue: state.passportAuthorityCode,
                  isRussianPassport: false,
                  kind: 'authority',
                })
                setValue('passportAuthorityCode', authorityCode, { shouldDirty: true })
              }}
              value={state.passportAuthorityCode}
              required={true}
              valid={
                passportDigits(state.passportAuthorityCode) &&
                !errors.passportAuthorityCode
              }
              onBlur={() => setFocus('')}
              focus={focus === 'passportAuthorityCode' || undefined}
              mask="999-999"
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport'}
              testErrorName={'error-F_Scan_Directors_Passport'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.mainImageFile}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport', [...(getValues('F_Scan_Directors_Passport')||[]), data], { shouldDirty: true })
              }}
              valid={!errors.F_Scan_Directors_Passport}
              documentType="Passport1"
              value={
                state.F_Scan_Directors_Passport[
                state.F_Scan_Directors_Passport.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport_Address'}
              testErrorName={'error-F_Scan_Directors_Passport_Address'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.addressImageFile}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport_Address', [...(getValues('F_Scan_Directors_Passport_Address')||[]), data], { shouldDirty: true })
              }}
              valid={
                !errors.F_Scan_Directors_Passport_Address
              }
              documentType="Passport2"
              value={
                state.F_Scan_Directors_Passport_Address[
                state.F_Scan_Directors_Passport_Address.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            {/* PASSPORT DATE BOARDING*/}
            <DatePicker
              testName={'passportDateBoardCrossing'}
              testErrorName={'error-passportDateBoardCrossing'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateBoardCrossing"
              onChange={data =>
                setValue('passportDateBoardCrossing', data, { shouldDirty: true })
              }
              value={state.passportDateBoardCrossing}
              required
              valid={
                !errors.passportDateBoardCrossing &&
                validateDate({
                  current: state.passportDateBoardCrossing,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              max={new Date()}
            />
          </div>
          <div
            className={'col-12 dateBoardCheckBox'}
          >
            <CheckBoxInput
              data-test-id="passportDateBoardCheck"
              name="passportDateBoardCheck"
              onChange={() =>
                setValue('passportDateBoardCheck', !state.passportDateBoardCheck, { shouldDirty: true })
              }
              label={accountForm.passportDateBoardCheck90.label}
              lang={lang}
              value={state.passportDateBoardCheck ?? false}
              valid={!!errors.passportDateBoardCheck}
            />
          </div>
        </>
      ) : Number(state.passportType) === PassportType.InternationalPassport ? (
        <>
          <div className="col-4 col-xs-12">
            {/* PASSPORT INTERNETIONAL NUMBER */}
            <TextInput
              testName={'passportInternationalNumber'}
              testErrorName={'error-passportInternationalNumber'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.passportInternationalNumberRus}
              onChange={passportInternationalNumber => {
                setValue('passportInternationalNumber', passportInternationalNumber, { shouldDirty: true })
              }}
              value={state.passportInternationalNumber}
              required
              valid={
                passportDigits(state.passportInternationalNumber) &&
                !errors.passportInternationalNumber
              }
              onBlur={() => setFocus('')}
              mask={'99 9999999'}
            />
          </div>
          <div className="col-2 col-xs-12">
            {/* PASSPORT ISSUE DATE */}
            <DatePicker
              testName={'passportIAt'}
              testErrorName={'error-passportIAt'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportIAt"
              onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
              value={state.passportIAt}
              required
              valid={
                !errors.passportIAt &&
                validateDate({
                  current: state.passportIAt,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              curr={new Date()}
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 10))
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* PASSPORT ISSUED BY */}
            <TextInput
              testName={'passportIssuedBy'}
              testErrorName={'error-passportIssuedBy'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT EXPIRY DATE */}
            <DatePicker
              testName={'passportExpiryDate'}
              testErrorName={'error-passportExpiryDate'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportExpiryDate"
              onChange={data =>
                setValue('passportExpiryDate', data, { shouldDirty: true })
              }
              value={state.passportExpiryDate}
              required
              valid={
                !errors.passportExpiryDate &&
                validateDate({
                  current: state.passportExpiryDate,
                  min: new Date(),
                  max: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 10)
                  ),
                })
              }
              onBlur={() => setFocus('')}
              min={
                new Date
              }
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
              }
            />
          </div>
          <div className="col-4 col-xs-12">
            {/* PASSPORT DATE BOARDING*/}
            <DatePicker
              testName={'passportDateBoardCrossing'}
              testErrorName={'error-passportDateBoardCrossing'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateBoardCrossing"
              onChange={data =>
                setValue('passportDateBoardCrossing', data, { shouldDirty: true })
              }
              value={state.passportDateBoardCrossing}
              required
              valid={
                !errors.passportDateBoardCrossing &&
                validateDate({
                  current: state.passportDateBoardCrossing,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              max={new Date()}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport'}
              testErrorName={'error-F_Scan_Directors_Passport'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.internationalFile}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport', [...(getValues('F_Scan_Directors_Passport')||[]), data], { shouldDirty: true })
              }}
              valid={!errors.F_Scan_Directors_Passport}
              documentType="Passport1"
              value={
                state.F_Scan_Directors_Passport[
                state.F_Scan_Directors_Passport.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport_Address'}
              testErrorName={'error-F_Scan_Directors_Passport_Address'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.arrivalStampFile}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport_Address', [...(getValues('F_Scan_Directors_Passport_Address')||[]), data], { shouldDirty: true })
              }}
              valid={
                !errors.F_Scan_Directors_Passport_Address
              }
              documentType="Passport2"
              value={
                state.F_Scan_Directors_Passport_Address[
                state.F_Scan_Directors_Passport_Address.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
        </>
      ) : Number(state.passportType) === PassportType.ResidencePermit ? (
        <>
          <div className="col-2 col-xs-12">
            {/* PASSPORT PERMANENT RESIDENCY DATE */}
            <DatePicker
              testName={'passportDateIssuePermanentResidency'}
              testErrorName={'error-passportDateIssuePermanentResidency'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateIssuePermanentResidency"
              onChange={data =>
                setValue('passportDateIssuePermanentResidency', data, { shouldDirty: true })
              }
              value={state.passportDateIssuePermanentResidency}
              required
              valid={
                !errors.passportDateIssuePermanentResidency &&
                validateDate({
                  current: state.passportDateIssuePermanentResidency,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              min={new Date(
                new Date().setFullYear(new Date().getFullYear() - 10) + (60 * 60 * 24 * 1000)
              )}
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* ISSUED BY */}
            <TextInput
              testName={'passportIssuedBy'}
              testErrorName={'error-passportIssuedBy'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport'}
              testErrorName={'error-F_Scan_Directors_Passport'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.residenceFileMainFiscal}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport', [...(getValues('F_Scan_Directors_Passport')||[]), data], { shouldDirty: true })
              }}
              valid={!errors.F_Scan_Directors_Passport}
              documentType="Passport1"
              value={
                state.F_Scan_Directors_Passport[
                state.F_Scan_Directors_Passport.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport_Address'}
              testErrorName={'error-F_Scan_Directors_Passport_Address'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.residenceFileSecondFiscal}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport_Address', [...(getValues('F_Scan_Directors_Passport_Address')||[]), data], { shouldDirty: true })
              }}
              valid={
                !errors.F_Scan_Directors_Passport_Address
              }
              documentType="Passport2"
              value={
                state.F_Scan_Directors_Passport_Address[
                state.F_Scan_Directors_Passport_Address.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
        </>
      ) : null}
    </>
  )
}
